import React, { useState, useContext } from 'react';
import Navbar from '../layouts/navbar';
import './login.css';
import Parse from 'parse';
import swal from 'sweetalert';
import { AuthContext } from '../../auth';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';


export const Register = () => {
    const [name, setName] = useState('');
    const [type, setType] = useState('');
    const [password, setPassword] = useState('');
    const [cpassword, setCpassword] = useState('');
    const [logedinuser, setLogedinuser] = useContext(AuthContext);
    const [registered, setregistered] = useState('false');
    let display;

    // const renderRedirect = () => {
    //     return <Redirect to='/login' />
    // }


    const handleSubmit = (e) => {
        e.preventDefault();

        console.log("submit called");
        const user = new Parse.User();
        console.log(name);
        console.log(password);
        if (password !== cpassword) {
            swal("Oops!", "Password dont match :(", "error");
        } else {

            user.set("username", name);
            user.set("name", name);
            user.set("type", type);
            user.set("password", password);
            user.set("cpassword", cpassword);
            user.set("isCounsellor", false);
            user.signUp()
                .then((data) => {
                    console.log(data.id);
                    setName("");
                    setPassword("");
                    setCpassword("");
                    // const user = Parse.Object.extend("User");
                    const query = new Parse.Query(user);

                    query.equalTo("isCounsellor", true).find().then((counsellor) => {
                        console.log(counsellor);
                        // console.log(counsellor[Math.floor((Math.random() * counsellor.length) )].id);
                        const counsl = counsellor[Math.round((Math.random() * counsellor.length))]
                        console.log(counsl.id);
                        // Parse.Cloud.run('updateCounsellor', { patient: data.id, cid: counsl.id })

                        let query = new Parse.Query(user)
                        query.get(data.id).then((user) => {
                            console.log(user)
                            user.set("counsellor", counsl.id)
                            user.save();
                        }).catch((error) => {
                            console.log(error)
                        })

                        // let query = new Parse.Query(user);
                        // query.get(counsl.id).then((counselor) => {
                        //     //add patients to counselor
                        //     console.log(counselor.get('patients'))
                        //     // counselor.set("patients",[...counselor.get('patients'),data.id])
                        //     // counselor.save();

                        //     //add counsellor to user


                        // })

                        // counsl.set("patients",[...counsl.get('patients'),data.id])

                        // console.log(data.id);
                        // let query = new Parse.Query(user);

                        // query.get(data.id).then((user) => {
                        //     console.log(user)
                        //     user.set("counsellor", counsl.id)
                        //     user.save();
                        // }).catch((error) => {
                        //     console.log(error)
                        // })

                    }, (error) => {
                        console.log(error)
                    })

                    swal("Added!", "User successfully added", "success");
                    setregistered("true");


                    // query users where isCounsellor true
                    // randomly select one of the objects
                    // assign this to counsellor field of the newly created user
                    // append newly created user to counsellor patient field



                }).catch((error) => {
                    console.log(error);
                    swal("Oops!", "no user..wrong email or password", "error");
                    // alert(error);
                })
        }


    }


    return (
        <div>
            {console.log(type,"type")}
            {console.log(registered, "register")}
            {(registered === "true") && (
                <Redirect to="/login" />
            )
            }

            <Navbar head="Register" />
            {console.log(logedinuser, "called")}
            {(logedinuser != null) && (
                <Redirect to="/login" />
            )}
            <div className="container cnt" style={{marginTop:"50px"}}>
                <form onSubmit={handleSubmit}>
                    <h1 className="head1">Create an Account</h1>
                    <div className="row ">
                        <div className="form-group  col-lg-12  ">
                            <input type="text"
                                className="form-control "
                                id="usr"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                placeholder="user name" />
                        </div>
                        <div className="form-group col-lg-12  ">
                            <input type="password"
                                className="form-control"
                                id="pwd"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                placeholder="Password" />
                        </div>
                        <div className="form-group col-lg-12  ">
                            <input type="password"
                                className="form-control"
                                id="pwd2"
                                value={cpassword}
                                onChange={e => setCpassword(e.target.value)}
                                placeholder="Confirm Password" />
                        </div>
                        <div className="mx-auto">
                            <select class="form-control form-control-lg" onChange={e =>{setType(e.target.value)}}>
                                <option value=''>Choose</option>
                                <option value="familymember">Family Member</option>
                                <option value="dependant">Dependant</option>
                            </select>
                        </div>

                        <div className="col-lg-12  policy">
                            <p><Link to="/forum">Terms and condition and privacy policy</Link></p>
                            {display}
                        </div>

                    </div>
                    {/* <input
                        type="submit"
                            className="submit btn-primary center-block mt-4" /> */}
                    <div className="btndiv">
                        <button type="submit" class="authbtn btn-primary mt-4">Submit</button>
                    </div>
                </form>
                <div className="signupdiv">Already have an account? <br /><Link to="/login">click here to Login</Link></div>
            </div>
        </div>
    );
};



export default Register;


